import { useEffect, useState } from "react";
import axios from "axios";
import { ChevronLeft, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HeroCarousel() {
  const [images, setImages] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const load = () => axios.get(`${API}/hero-images`, { params: { _: Date.now() } })
      .then(({ data }) => setImages(data.items || []))
      .catch(() => {});
    load();
    const onChange = () => load();
    window.addEventListener("hp:hero-changed", onChange);
    window.addEventListener("focus", onChange);
    return () => {
      window.removeEventListener("hp:hero-changed", onChange);
      window.removeEventListener("focus", onChange);
    };
  }, []);

  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % images.length), 5000);
    return () => clearInterval(t);
  }, [images.length]);

  if (images.length === 0) return null;
  const current = images[idx % images.length];
  const prev = () => setIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setIdx((i) => (i + 1) % images.length);

  return (
    <div className="relative rounded-2xl overflow-hidden border-4 border-[#0C2E2B] shadow-2xl" data-testid="hero-carousel">
      {images.map((img, i) => (
        <img
          key={img.id}
          src={img.image_url}
          alt={img.caption || "Harvey's Place"}
          className={`w-full h-[420px] object-cover transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0 absolute inset-0"}`}
          data-testid={`hero-image-${i}`}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0C2E2B]/80 via-transparent to-transparent pointer-events-none" />
      {images.length > 1 && (
        <>
          <button data-testid="hero-prev-btn" onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/90 grid place-items-center hover:bg-white">
            <ChevronLeft className="w-5 h-5 text-[#0C2E2B]" />
          </button>
          <button data-testid="hero-next-btn" onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/90 grid place-items-center hover:bg-white">
            <ChevronRight className="w-5 h-5 text-[#0C2E2B]" />
          </button>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5" data-testid="hero-dots">
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                data-testid={`hero-dot-${i}`}
                className={`w-2 h-2 rounded-full transition-all ${i === idx ? "bg-[#FFDF00] w-6" : "bg-white/60"}`}
              />
            ))}
          </div>
        </>
      )}
      {current?.caption && (
        <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur rounded-lg px-3 py-2">
          <div className="font-tactical text-[10px] uppercase tracking-[0.2em] text-[#0C2E2B]">{current.caption}</div>
        </div>
      )}
    </div>
  );
}
